import ModalRamals from '@/components/templates/ModalRamals';
import { modalActions } from '@/store/features/modal/modalSlice';

interface RamalSelecionado {
  label: string;
  value: string;
}

export function requestChannell(dispatch: any): Promise<RamalSelecionado> {
  return new Promise((resolve) => {
    dispatch(
      modalActions.add({
        component: ModalRamals,
        disableBackdropClick: true,
        props: { resolve },
      }),
    );
  });
}
